export const FILTER_LABELS = {
  asset_tag: 'Asset tag',
  asset_owner: 'Asset owner',
  asset_name: 'Asset name',
  asset_subscriber: 'Asset subscriber',
  asset_path: 'Asset path',
  is_critical: 'Is critical',
  database_name: 'Database',
  schema_name: 'Schema',
  table_name: 'Table',
};
